import React, { type FC } from 'react';
import { FormattedMessage, type MessageDescriptor } from 'react-intl-next';

import { Text } from '@atlaskit/primitives';

import { ConfluenceEdition } from '@confluence/session-data';

type SubHeadingProps = {
	edition: ConfluenceEdition | null;
	text: MessageDescriptor;
	daysLeftTrial: number | null;
};

type SubHeadingMessageProps = {
	text: MessageDescriptor;
	daysLeftTrial?: number | null;
};

const SubHeadingFree: FC<SubHeadingMessageProps> = ({ text }) => {
	return (
		<Text color="color.text.subtle">
			<FormattedMessage {...text} />
		</Text>
	);
};

const SubHeadingStandard: FC<SubHeadingMessageProps> = ({ text, daysLeftTrial }) => {
	return (
		<Text color="color.text.subtle">
			<FormattedMessage {...text} values={{ daysRemaining: daysLeftTrial }} />
		</Text>
	);
};

export const SubHeading: FC<SubHeadingProps> = ({ edition, text, daysLeftTrial }) => {
	return (
		<>
			{edition === ConfluenceEdition.FREE ? (
				<SubHeadingFree text={text} />
			) : (
				<SubHeadingStandard text={text} daysLeftTrial={daysLeftTrial} />
			)}
		</>
	);
};
